export default {"src":"/_next/static/media/share-icon-card.95cffe2b.svg","height":25,"width":24};